import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios';
import Lockr from 'lockr';
import Util from './libs/util';
import appService from './libs/appService';
import 'video.js/dist/video-js.css';
import VideoPlayer from 'vue-video-player'

import VueClipboard from 'vue-clipboard2'

// import echarts from 'echarts'

// import Vconsole from 'vconsole'

if(process.env.VUE_APP_CONSOLE == 1) {
  // let vConsole = new Vconsole()
}

// Vue.prototype.$echarts = echarts
Vue.use(VideoPlayer);
Vue.use(VueClipboard)

import getAuthorization from './libs/authorization';
Vue.prototype.getAuthorization=getAuthorization;

import { Toast, Dialog, Lazyload, ImagePreview } from 'vant';
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ImagePreview);

// require('vue-video-player/node_modules/video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');

import 'amfe-flexible'

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

axios.defaults.withCredentials = true
axios.defaults.timeout = 1000 * 15
axios.defaults.baseURL='https://m.motortime.com'
Vue.prototype.$util = Util;
Vue.prototype.$appService = appService;

window.Lockr = Lockr;
window.axios = axios;

router.beforeEach(function (to, from, next) {
  Util.title(to.meta.title);

  let source = to.query.source;
  if(source)
    store.dispatch('param/setSource', source);

  appService.getToken(v => {
    if(v.token) {
      store.dispatch('param/setToken', v.token);
    }
  });
  if(source == 6) {
    Vue.use(Lazyload, {
      loading: require('./assets/img/default_lexus.png')
    });
  }else if(source == 8) {
    Vue.use(Lazyload, {
      loading: require('./assets/img/default_lexus.png')
    });
  }else{
    Vue.use(Lazyload, {
      loading: require('./assets/img/default_img.png')
    });
  }

  //测试用
  // Lockr.set('token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJjcXdhdGVyIiwiYXVkIjoiY3F3YXRlciIsImlhdCI6MTU3MTcxNDA4NiwibmJmIjoxNTcxNzE0MDg2LCJtaWQiOjExNjM2fQ.u_iD8GVwpyRfaXnniSk78ddEE7GOYElT8_ApDmRxC3moALzA7fNW2m_jbM6C3uUVHcUmjNbz3FzXEn1uKji7BQ')
  if(Lockr.get('token')) {
    store.dispatch('param/setToken', Lockr.get('token'))
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if(to.meta.keywords){
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.description)
  }
  if (_hmt) {
    if (to.path) {
     _hmt.push(['_trackPageview', '/#' + to.fullPath]);
   }
 }
 if(to.matched.length==0){
  router.push({
    path:'/'
  })
}else{
  next()
}
})

router.afterEach((to, from, next) => {
  // window.scrollTo(0, 0)
  store.commit('param/position', {
    name: from.path,
    position: document.body.scrollTop || document.documentElement.scrollTop
  })

  if (store.state.param.positions && store.state.param.positions[to.path]) {
    setTimeout(() => {
      window.scrollTo(0, store.state.param.positions[to.path])
    }, 1)
  } else {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 1)
  }
})

axios.interceptors.response.use(response => {
  if(!response.data.state) {
    Toast(response.data.error.join('，'))
  }
  return response
}, error => {
  switch (error.response.status) {
    case 500:
    Toast('服务器内部错误')
    break;
    case 401:
    // Toast('登录失效，请重新登录')
    break;
    case 403:
    Toast('禁止访问')
    break;
  }
  return Promise.reject(error);
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
